import React from "react"

const ProductPickupPointInfo = ({ point: product_pickup_point, showName = true }) => (
  <span>
    {product_pickup_point.location_map_url && (
      <a href={product_pickup_point.location_map_url} target="_blank">
        {showName ? product_pickup_point.location_name : I18n.t("fe.NewOrderView.show_on_map")}
      </a>
    )}
    {product_pickup_point.departure_time && (
      <div>
        <span>{I18n.humanAttributeName("product_pickup_point", "departure_time")}:</span> {st.formatTime(product_pickup_point.departure_time, { format: "time" })}
      </div>
    )}
    {product_pickup_point.arrival_time && (
      <div>
        <span>{I18n.humanAttributeName("product_pickup_point", "arrival_time")}:</span> {st.formatTime(product_pickup_point.arrival_time, { format: "time" })}
      </div>
    )}
    {product_pickup_point.additional_instructions && (
      <div>
        <span>{I18n.humanAttributeName("product_pickup_point", "additional_instructions")}:</span> {product_pickup_point.additional_instructions}
      </div>
    )}
  </span>
)

export default ProductPickupPointInfo


// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/components/ProductPickupPointInfo.jsx